var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tiptap__bubble-menu-separator"})
}
var staticRenderFns = []

export { render, staticRenderFns }